import React from 'react';
import { Modal } from 'flowbite-react';
import { LeadData } from 'types';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    data: LeadData | null;
}

const AlternativeContactDetailsModal: React.FC<Props> = ({ isOpen, onClose, data }) => {
    if (!data) return null;

    return (
        <Modal show={isOpen} onClose={onClose} size="md">
            <Modal.Header>Alternative Contact Details</Modal.Header>
            <Modal.Body>
                <div className="flex flex-col gap-2">
                    <div><b>Name 1:</b> {data.alternativeName1 ? data.alternativeName1 : "--"}</div>
                    <div><b>Email 1:</b> {data.alternativeEmail1 ? data.alternativeEmail1 : "--"}</div>
                    <div><b>Phone 1:</b> {data.alternativePhone1 ? data.alternativePhone1 : "--"}</div>
                    <div><b>Name 2:</b> {data.alternativeName2 ? data.alternativeName2 : "--"}</div>
                    <div><b>Email 2:</b> {data.alternativeEmail2 ? data.alternativeEmail2 : "--"}</div>
                    <div><b>Phone 2:</b> {data.alternativePhone2 ? data.alternativePhone2 : "--"}</div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AlternativeContactDetailsModal;